module.exports = __webpack_public_path__ + "img/reno-bati.104d277d.svg";